import styled from "@emotion/styled";

export const POSContainer = styled.div`
  padding: 20px;
  background: #f9fafb;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex: 1;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const LeftPanel = styled.div`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RightPanel = styled.div`
  flex: 1;
  position: sticky;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (max-width: 1024px) {
    position: relative;
    top: 0;
    width: 100%;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: #f3f4f6;
  border-radius: 8px;
  margin-bottom: 20px;

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    font-size: 15px;
    padding: 8px 0;
  }
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  margin-top: 20px;
`;

export const ProductCard = styled.div<{ selected?: boolean }>`
  border: 1px solid ${({ selected }) => (selected ? "#10B981" : "#e5e7eb")};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s;
  background: ${({ selected }) => (selected ? "#f0fdf4" : "white")};
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 6px;
  }
`;

export const CartList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 20px;
`;

export const CartItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
`;

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 2px 8px;

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #4b5563;
    padding: 0 4px;
    
    &:hover {
      color: #10b981;
    }
  }

  span {
    min-width: 20px;
    text-align: center;
    font-weight: 600;
  }
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  
  &:hover {
    background: #fee2e2;
  }
`;

export const EmptyCart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #9CA3AF;
  gap: 10px;
`;

export const TotalsArea = styled.div`
  background: #f9fafb;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
`;

export const TotalsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 12px 0;
`;

export const DeliveryToggle = styled.div`
  display: flex;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 20px;
`;

export const ToggleOption = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background: ${({ active }) => (active ? "white" : "transparent")};
  color: ${({ active }) => (active ? "#111827" : "#6B7280")};
  font-weight: ${({ active }) => (active ? "600" : "500")};
  box-shadow: ${({ active }) => (active ? "0 1px 3px rgba(0,0,0,0.1)" : "none")};
  cursor: pointer;
  transition: all 0.2s;
`;

export const SearchDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  max-height: 250px;
  overflow-y: auto;
  z-index: 50;
  margin-top: 4px;
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: #f9fafb;
  }
`;

export const OptionSection = styled.div`
  margin-bottom: 20px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: ${({ disabled }) => (disabled ? "#f9fafb" : "white")};
  color: ${({ disabled }) => (disabled ? "#9ca3af" : "#374151")};
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #d1d5db;
  }
`;


